var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6757 4H8.32432C7.17744 4 6.07753 4.4958 5.26657 5.37832C4.4556 6.26085 4 7.4578 4 8.70588V15.2941C4 15.9121 4.11185 16.524 4.32917 17.095C4.54649 17.6659 4.86501 18.1847 5.26657 18.6217C6.07753 19.5042 7.17744 20 8.32432 20H15.6757C16.2436 20 16.8059 19.8783 17.3305 19.6418C17.8552 19.4053 18.3319 19.0587 18.7334 18.6217C19.135 18.1847 19.4535 17.6659 19.6708 17.095C19.8881 16.524 20 15.9121 20 15.2941V8.70588C20 8.0879 19.8881 7.47596 19.6708 6.90502C19.4535 6.33408 19.135 5.8153 18.7334 5.37832C18.3319 4.94134 17.8552 4.59471 17.3305 4.35821C16.8059 4.12172 16.2436 4 15.6757 4Z",
    stroke: "#4776E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17L7.2578 13.8473C7.55324 13.4952 7.94098 13.2764 8.3554 13.2279C8.76983 13.1794 9.18548 13.3043 9.53202 13.5813C9.87856 13.8583 10.2942 13.9831 10.7086 13.9347C11.1231 13.8862 11.5108 13.6674 11.8062 13.3153L13.7192 11.0197C14.2689 10.3579 14.9966 9.95193 15.7726 9.87433C16.5486 9.79673 17.3223 10.0525 17.9557 10.5961L20 12.4975M9.10509 10.2709C9.28407 10.2709 9.46129 10.2286 9.62665 10.1464C9.792 10.0643 9.94224 9.94379 10.0688 9.79192C10.1954 9.64005 10.2957 9.45976 10.3642 9.26133C10.4327 9.06291 10.468 8.85024 10.468 8.63547C10.468 8.4207 10.4327 8.20803 10.3642 8.0096C10.2957 7.81118 10.1954 7.63088 10.0688 7.47902C9.94224 7.32715 9.792 7.20668 9.62665 7.12449C9.46129 7.0423 9.28407 7 9.10509 7C8.74363 7 8.39697 7.17231 8.14138 7.47902C7.88579 7.78573 7.7422 8.20172 7.7422 8.63547C7.7422 9.06922 7.88579 9.48521 8.14138 9.79192C8.39697 10.0986 8.74363 10.2709 9.10509 10.2709Z",
    stroke: "#4776E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImage);
export default __webpack_public_path__ + "static/media/ic-image.14a01584cdf6c7007851bbbee0306a4a.svg";
export { ForwardRef as ReactComponent };